import React from "react";
import Section from "@/components/ui/section";
export default function AdditonalResources({ data }) {
  return (
    <Section>
      <div className="w-full flex flex-col gap-4 items-start justify-start border-dashed border-[1px] border-darkBlue p-8 bg-white rounded-2xl">
        <h5 className="text-darkBlue text-left font-semibold">
          For more information, please read our recently released research
          report:
        </h5>

        <a
          href="/pdfs/PCI RESEARCH REPORT FINAL.pdf"
          target="_blank"
          rel="noreferrer"
          className="underline text-darkBlue hover:text-lightBlue transition-all duration-300 ease"
        >
          Coping with Climate: How extreme weather is already impacting internal
          migrants (A comprehensive study across 5 countries in South and
          Southeast Asia).
        </a>

        <div className="rounded-2xl flex flex-col w-full mx-auto mt-4">
          <p className="text-darkBlue mb-4 text-left font-semibold">
            Additional Resources
          </p>
          <ul className="list-decimal w-full flex flex-col gap-4 justify-start items-start pl-6 md:text-base text-sm">
            {data.map((row, key) => (
              <li className="" key={"learMore" + key}>
                <a
                  href={row.link}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-lightBlue text-body transition-all duration-300 ease"
                >
                  {row.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
}
